let module = {};

/**
 * Container Initialization
 */
module.init = function () {
	const filterOffering = document.getElementById('filterOffering');
	const filters = [filterOffering];

	filterOffering.addEventListener('change', () => {
		module.handleFilterChanges(filters);
	});
};

module.handleFilterChanges = (filters) => {
	const searchParams = new URLSearchParams();
	for (let filter of filters) {
		if (filter.value) {
			searchParams.set(filter.getAttribute('data-filter'), filter.value);
		}
	}

	// check to see if user is filtering from a paged view
	// if so redirect them to page 1
	var urlString = window.location.href;

	if (urlString.includes('/page/')) {
		location.href = '/reviews/?' + searchParams.toString();
	} else {
		location.search = searchParams.toString();
	}
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});
